import * as t from "io-ts";
import * as JsonResponse1 from "./JsonResponse1";
import * as CaseDocument6 from "./CaseDocument6";

export const codec = JsonResponse1.createCodec(
    t.array(CaseDocument6.codec),
    t.type({}),
);

export type T = t.TypeOf<typeof codec>;

export const newDefault = (): T => ({
    data: [],
    meta: {},
});
